<template>
  <div class="table34">
    <el-table :data="table_data_list" height="850" style="width: 100%">
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.data1 }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.data2 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="data3"
        label="申购起始"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="data4"
        label="申购截止"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="data5"
        label="上市日"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="data6"
        label="询问区间"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
        prop="data7"
        label="绿鞋保护/公开发售"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_data_list: [
        {
          data1: "中天转债",
          data2: "002410",
          data3: "2022-11-12",
          data4: "2022-11-19",
          data5: "2022-11-12",
          data6: "1-1.2",
          data7: "1500.00%",
        },
      ],
    };
  },
};
</script>

<style scoped>
.table34 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table34 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table34 /deep/ .cell {
  padding: 0;
}
.table34 /deep/ .el-table th.el-table__cell > .cell {
  padding: 0;
}
</style>